/* ── Pro Import — Home page JS ──────────────────────────────────────────── */
(function () {
  'use strict';

  /* ── Helpers ──────────────────────────────────────────────────────────── */
  var BIKE_SVG = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#9B1B1B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="6" cy="17" r="3"/><circle cx="18" cy="17" r="3"/><path d="m9 17 4-8 3 3h2"/><path d="m9 5 2 2-1 3"/></svg>';
  var VAN_SVG  = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#9B1B1B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="8" width="14" height="9"/><path d="M16 11h4l2 3v3h-6"/><circle cx="6" cy="19" r="2"/><circle cx="18" cy="19" r="2"/></svg>';
  var ARROW_R  = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m13 6 6 6-6 6"/></svg>';
  var GRID_ICO = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>';
  var LIST_ICO = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><circle cx="4" cy="6" r="1"/><circle cx="4" cy="12" r="1"/><circle cx="4" cy="18" r="1"/></svg>';

  function tagBg(tag) {
    if (tag === 'BEST SELLER') return 'background:#9B1B1B;color:#fff;';
    if (tag === 'NEW')         return 'background:#0A0A0A;color:#fff;';
    if (tag === 'OEM')         return 'background:#1E40AF;color:#fff;';
    if (tag === 'TOP SELLER')  return 'background:#9B1B1B;color:#fff;';
    return 'background:#E5E5E5;color:#0A0A0A;';
  }

  function partIcon(category) {
    if (category === 'body') {
      return '<svg width="70" height="70" viewBox="0 0 100 70" fill="none"><rect x="5" y="22" width="90" height="32" rx="6" fill="#D4D4D4"/><rect x="20" y="10" width="58" height="22" rx="4" fill="#C0C0C0"/><rect x="0" y="38" width="18" height="16" rx="3" fill="#BCBCBC"/><rect x="82" y="38" width="18" height="16" rx="3" fill="#BCBCBC"/></svg>';
    }
    return '<svg width="70" height="70" viewBox="0 0 100 100" fill="none"><circle cx="50" cy="50" r="40" stroke="#D4D4D4" stroke-width="10" fill="none"/><circle cx="50" cy="50" r="20" fill="#D4D4D4"/><circle cx="50" cy="50" r="8" fill="#BCBCBC"/></svg>';
  }

  function prodCardHTML(p) {
    var tagHtml = p.tag ? '<span class="prod-tag-badge" style="' + tagBg(p.tag) + '">' + p.tag + '</span>' : '';
    var stockHtml = p.stock === 'in'
      ? '<span class="prod-stock-in">● In stock</span>'
      : '<span class="prod-stock-low">● Low stock</span>';
    return '<a class="prod-card" href="product.html?sku=' + encodeURIComponent(p.sku) + '">'
      + '<div class="prod-thumb">' + tagHtml + partIcon(p.category) + '</div>'
      + '<div class="prod-body">'
      + '<div class="prod-sku">' + p.sku + '</div>'
      + '<div class="prod-name">' + p.name + '</div>'
      + '<div class="prod-compat">' + p.brand + ' ' + p.model + '</div>'
      + '<div class="prod-footer"><span class="prod-price">£' + p.price + '</span>' + stockHtml + '</div>'
      + '<div class="prod-cta">ENQUIRE NOW →</div>'
      + '</div>'
      + '</a>';
  }

  function buildScroller(containerId, btnPrevId, btnNextId, products) {
    var track = document.getElementById(containerId);
    if (!track) return;
    track.innerHTML = products.map(prodCardHTML).join('');
    var prev = document.getElementById(btnPrevId);
    var next = document.getElementById(btnNextId);
    if (prev) prev.addEventListener('click', function () { track.scrollLeft -= 560; });
    if (next) next.addEventListener('click', function () { track.scrollLeft += 560; });
  }

  /* ── Hero carousel ────────────────────────────────────────────────────── */
  function initHero() {
    var slides = document.querySelectorAll('.hs');
    var dots   = document.querySelectorAll('.hero-dot');
    if (!slides.length) return;
    var cur = 0, timer;

    function goTo(n) {
      slides[cur].classList.remove('active');
      dots[cur].classList.remove('active');
      cur = (n + slides.length) % slides.length;
      slides[cur].classList.add('active');
      dots[cur].classList.add('active');
    }
    function startAuto() { timer = setInterval(function () { goTo(cur + 1); }, 7000); }
    function resetAuto()  { clearInterval(timer); startAuto(); }

    var prev = document.getElementById('heroPrev');
    var next = document.getElementById('heroNext');
    if (prev) prev.addEventListener('click', function () { goTo(cur - 1); resetAuto(); });
    if (next) next.addEventListener('click', function () { goTo(cur + 1); resetAuto(); });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { goTo(i); resetAuto(); });
    });
    startAuto();
  }

  /* ── Brand colour map for lettermarks ───────────────────────────────── */
  var BRAND_CLR = {
    bajaj:'#004C97', benelli:'#8B0000', bmw:'#1C2B5A', ducati:'#C8102E',
    honda:'#CC0000', triumph:'#0A0A0A', ktm:'#E84F0E', kawasaki:'#006633',
    cfmoto:'#C8102E', suzuki:'#003087', sym:'#005BAC', yamaha:'#003087', van:'#2A3A4A'
  };

  /* ── Brand cards ──────────────────────────────────────────────────────── */
  function buildBrandsGrid() {
    var grid = document.getElementById('brandsGrid');
    if (!grid || !window.PI) return;
    grid.innerHTML = PI.BRANDS.map(function (b) {
      var clr = BRAND_CLR[b.id] || '#9B1B1B';
      var initials = b.name.replace(/\s+/g,'').substring(0,2).toUpperCase();
      return '<a class="brand-card" href="category.html?brand=' + b.id + '&model=' + b.models[0].id + '">'
        + '<div class="brand-logo-mark" style="background:' + clr + ';">' + initials + '</div>'
        + '<div class="brand-card-name">' + b.name + '</div>'
        + '<div class="brand-card-count">' + b.models.length + ' models</div>'
        + '</a>';
    }).join('');
  }

  /* ── Part finder ──────────────────────────────────────────────────────── */
  function initPartFinder() {
    if (!window.PI) return;
    var brandSel    = document.getElementById('finderBrand');
    var modelSel    = document.getElementById('finderModel');
    var finderForm  = document.getElementById('finderForm');
    if (!brandSel || !modelSel) return;

    // Populate brand options
    brandSel.innerHTML = PI.BRANDS.map(function (b) {
      return '<option value="' + b.id + '">' + b.name + '</option>';
    }).join('');

    function populateModels(brandId) {
      var brand = PI.BRANDS.find(function (b) { return b.id === brandId; });
      if (!brand) return;
      modelSel.innerHTML = brand.models.map(function (m) {
        return '<option value="' + m.id + '">' + m.name + '</option>';
      }).join('');
    }
    populateModels(PI.BRANDS[0].id);

    brandSel.addEventListener('change', function () { populateModels(this.value); });

    if (finderForm) {
      finderForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var brand    = brandSel.value;
        var model    = modelSel.value;
        var catSel   = document.getElementById('finderCat');
        var cat      = catSel ? catSel.value : '';
        var url = 'category.html?brand=' + brand + '&model=' + model;
        if (cat && cat !== 'all') url += '&cat=' + cat;
        window.location.href = url;
      });
    }
  }

  /* ── Product scrollers ────────────────────────────────────────────────── */
  // function buildScrollers() {
  //   if (!window.PI || !PI.PRODUCTS) return;
  //   var bestSellers  = PI.PRODUCTS.filter(function (p) { return p.tag === 'BEST SELLER'; }).slice(0, 14);
  //   var newArrivals  = PI.PRODUCTS.filter(function (p) { return p.tag === 'NEW' || p.tag === 'OEM'; }).slice(0, 14);
  //   var bodyParts    = PI.PRODUCTS.filter(function (p) { return p.category === 'body'; }).slice(0, 14);
  //   var engineParts  = PI.PRODUCTS.filter(function (p) { return p.category === 'engine'; }).slice(0, 14);
  //   var mostEnquired = PI.PRODUCTS.slice().sort(function (a, b) { return b.reviews - a.reviews; }).slice(0, 14);
  //   buildScroller('bestScrollTrack',     'bestPrev',     'bestNext',     bestSellers);
  //   buildScroller('newScrollTrack',      'newPrev',      'newNext',      newArrivals);
  //   buildScroller('bodyScrollTrack',     'bodyPrev',     'bodyNext',     bodyParts);
  //   buildScroller('engineScrollTrack',   'enginePrev',   'engineNext',   engineParts);
  //   buildScroller('enquiredScrollTrack', 'enquiredPrev', 'enquiredNext', mostEnquired);
  // }

  /* ── Init ─────────────────────────────────────────────────────────────── */
  function init() {
    initHero();
    buildBrandsGrid();
    initPartFinder();
    buildScrollers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
